import { render, staticRenderFns } from "./DeliveryChallanEditItem.vue?vue&type=template&id=97a61706&scoped=true&"
import script from "./DeliveryChallanEditItem.vue?vue&type=script&lang=js&"
export * from "./DeliveryChallanEditItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a61706",
  null
  
)

export default component.exports